module.exports = __webpack_public_path__ + "static/media/tag-circle.bfc627f4.svg";